import React from 'react';

import { Modal } from 'components/v2/Modal/Modal';

import RiskAssessmentForm from './RiskAssessmentForm';
import RiskAssessmentFormType from '../types/RiskAssessmentForm';

interface Props {
  isOpen: boolean;
  form?: RiskAssessmentFormType;
  onClose: () => void;
  onSaveAnswer: (fieldId: number, answer: boolean) => Promise<any>;
  onSubmit: () => void;
}

const RiskAssessmentFormModal = ({ isOpen, form, onClose, onSaveAnswer, onSubmit }: Props) => {
  return (
    <Modal title="Pregnancy Assessment" open={isOpen} onCancel={onClose}>
      {!!form && <RiskAssessmentForm form={form} onSubmit={onSubmit} onSaveAnswer={onSaveAnswer} />}
    </Modal>
  );
};

export default RiskAssessmentFormModal;
